<template>
	<div>
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<el-button type="warning" size="mini" icon="el-icon-edit" @click="addKefu('')">添加客服</el-button>
				<el-button-group>
					<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
					<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
				</el-button-group>
				<el-dropdown trigger="click">
					<el-button type="primary" icon="el-icon-setting" size="mini">
						筛选
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, key) in items.seconds"
										:key="key"
										:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
										:class="item.checked ? 'color-blue' : ''"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteKefu">删除</el-button>
				<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getKefuList()">刷新</el-button>
				<el-dropdown trigger="click">
					<el-button type="success" icon="el-icon-setting" size="mini">
						设置
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in setList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, index) in items.seconds"
										:key="index"
										:command="{ setParam: items.paramValue, setParamVal: item.val }"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-table
					ref="multipleTable"
					:data="kefuList"
					style="width: 100%;margin-bottom: 20px;"
					row-key="cid"
					:stripe="true"
					:default-sort="{ prop: 'ctime', order: 'ascending' }"
					@sort-change="sortChange"
					@selection-change="selectChange"
					tooltip-effect="dark"
				>
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="cid" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="pid" label="排列号" width="100" sortable></el-table-column>
					<el-table-column prop="call_name" label="在线客服名称" show-overflow-tooltip></el-table-column>
					<el-table-column prop="call_type" label="在线客服类型">
						<template slot-scope="scope">
							{{ ['QQ', '淘宝旺旺', '阿里旺旺', '嵌入代码'][scope.row.call_type - 1] }}
						</template>
					</el-table-column>
					<el-table-column prop="is_type" label="图标类型">
						<template slot-scope="scope">
							{{ ['默认方式', '自定义'][scope.row.istype] }}
						</template>
					</el-table-column>
					<el-table-column prop="isclass" label="启用状态">
						<template slot-scope="scope">
							<i :class="scope.row.isclass ? 'el-icon-unlock color-green' : 'el-icon-lock color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="addKefu(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- dialog -->
				<el-dialog title="添加客服" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
					<el-form class="text-left" ref="attrForm" :rules="rules" :model="addScope">
						<el-form-item label="在线客服名称" :label-width="formLabelWidth" prop="call_name">
							<el-input v-model="addScope.call_name" autocomplete="off" placeholder="请输入在线客服名称，长度2至150位的任意字符"></el-input>
						</el-form-item>
						<el-form-item label="在线客服类型" :label-width="formLabelWidth" prop="call_type">
							<el-radio-group v-model="addScope.call_type">
								<el-radio :label="1">QQ</el-radio>
								<el-radio :label="2">淘宝旺旺</el-radio>
								<el-radio :label="3">阿里旺旺</el-radio>
								<el-radio :label="4">嵌入代码</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="图标类型" :label-width="formLabelWidth" prop="istype">
							<el-radio-group v-model="addScope.istype">
								<el-radio :label="0">默认方式</el-radio>
								<el-radio :label="1">指定图标</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item v-if="addScope.istype == 1" label="在线客服图标" :label-width="formLabelWidth" prop="pic">
							<el-button v-if="!addScope.pic" size="small" type="primary" @click="chooseIcon">上传图片</el-button>
							<div v-else class="upfile">
								<div class="delicon text-right"><i class="el-icon-delete" @click="delAdscopeImg"></i></div>
								<img v-if="addScope.pic" :src="HOST + addScope.pic" alt="" style="width: 150px;height: 150px;" />
							</div>
						</el-form-item>
						
						<el-form-item v-if="addScope.call_type == 4" label="嵌入代码" :label-width="formLabelWidth" prop="call_code">
							<el-input
								type="textarea"
								v-model="addScope.call_code"
								:rows="4"
								autocomplete="off"
								:autosize="{ minRows: 8, maxRows: 20 }"
								placeholder="请填写嵌入代码,长度为2至1500个以内任意字符"
							></el-input>
						</el-form-item>
						<el-form-item v-else label="客服账号" :label-width="formLabelWidth" prop="call_code">
							<el-input v-model="addScope.call_code" autocomplete="off" placeholder="请填写客服帐号,长度为2至100个以内任意字符"></el-input>
						</el-form-item>
					</el-form>

					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitRuleForm('attrForm')">确 定</el-button>
					</div>
				</el-dialog>
			</el-main>
		</el-container>
		<pic-list ref="piclist" @confirm="chooseIconConfirm"></pic-list>
	</div>
</template>
<script>
import Sortable from 'sortablejs';
import picList from '../../components/piclist/piclist.vue';
export default {
	name: '',
	components:{
		picList
	},
	data() {
		var picCheck = (rule, value, callback) => {
			if (this.addScope.istype == 1 && !value) {
				callback(new Error('请上传客服图标！'));
			} else {
				callback();
			}
		};
		var codeCheck = (rule, value, callback) => {
			switch (this.addScope.call_type) {
				case 1:case 2:case 3:
					if (!value) {
						callback(new Error('请输入客服账号'));
					} else {
						callback();
					}
					break;
				case 4:
					if (!value) {
						callback(new Error('请输入嵌入代码'));
					} else {
						callback();
					}
					break;
				default:
					callback();
					break;
			}
		};
		return {
			sort_param: '', //排序字段
			sort_type: '', //排序方式ascending = asc;descending = desc,'' = asc;
			kefuList: [],
			selectedKefuIds: [],
			filtrateList: [
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			setList: [
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			selectParams: [],
			dialogVisible: false,
			addScope: {
				call_type:1,
				call_style:0,
				call_name:'',
				call_code:'',
				pic:'',
				istype:0
			},
			albumDialogShow:false,
			formLabelWidth: '120px',
			linePics: [],
			pictotal:0,
			checkedLinePics: [],
			albumTab: 'uploadFile', //本地上传，chooseLineFile在线图片
			albumpage: 1,
			deliconShow: false,
			fileType: ['filename_pic', 'filename_file', 'filename_text'],
			rules: {
				call_name: [{ required: true, message: '请输入在线客服名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 150 个字符', trigger: 'blur' }],
				pic: [{ validator: picCheck, trigger: 'blur' }],
				call_code: [{ validator: codeCheck, trigger: 'blur' }],
			},
		};
	},
	mounted() {
		this.getKefuList(1);
	},
	methods: {
		// 行拖拽排序
		rowDrop(that) {
			// 此时找到的元素是要拖拽元素的父容器
			const tbody = document.querySelector('.el-table__body-wrapper tbody');
			const _this = that;
			Sortable.create(tbody, {
				// 指定父元素下可被拖拽的子元素
				draggable: '.el-table__row',
				onEnd({ newIndex, oldIndex }) {
					const currRow = _this.kefuList.splice(oldIndex, 1)[0];
					_this.kefuList.splice(newIndex, 0, currRow);
					console.log('行拖拽结果', 'newIndex:' + newIndex, 'oldIndex:' + oldIndex, 'currRow:', currRow);
					_this.kefuList.map((item, index) => {
						item.pid = index;
					});
					// 调用后台拖拽排序接口
					if (newIndex != oldIndex) {
						_this._updateMoveData();
					}
				}
			});
		},
		// 拖拽排序接口
		async _updateMoveData() {
			this.$axios({
				url: this.HOST + '/admin.document/updateKefuSort',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					kefuList: this.kefuList
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						console.log('已成功重排序');
					}
				})
				.catch(err => {});
		},
		// 全选
		selectAll() {
			this.kefuList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.kefuList.map(item => {
				if (this.selectedKefuIds.indexOf(item.cid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.cid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedKefuIds = diff;
			console.log(this.selectedKefuIds);
		},
		// 删除
		deleteKefu() {
			if (!this.selectedKefuIds.length) {
				this.$message.error('尚未选中任何客服信息！');
				return false;
			}
			this.$confirm('是否要删除所选客服信息？此操作一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.advertType/deleteKefu',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							cids: this.selectedKefuIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getKefuList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
			this.getKefuList();
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getKefuList();
		},
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setKefuParam();
		},
		setKefuParam() {
			if (!this.selectedKefuIds.length) {
				this.$message.error('尚未选中任何客服信息');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.advertType/setKefuParam',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					kefuIds: this.selectedKefuIds,
					setParam: this.setParam,
					setParamVal: this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.kefuList.map(item => {
							if (this.selectedKefuIds.indexOf(item.cid) !== -1) {
								item[this.setParam] = this.setParamVal;
							}
						});
						this.$message.success(res.data.msg);
						// this.selectedadIds = []//选中值初始化
					}
				})
				.catch(err => {});
		},
		getKefuList() {
			let separ = [];
			for (let i in this.selectParams) {
				console.log(i, this.selectParams[i]);
				separ.push({ param: i, paramVal: this.selectParams[i] });
			}
			this.$axios({
				url: this.HOST + '/admin.advertType/kefuList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					selectParams: separ
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.kefuList = res.data.list;
						let that = this;
						this.rowDrop(that); // 行拖拽排序
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			console.log(selection);
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].cid);
			}
			this.selectedKefuIds = arr;
			console.log(this.selectedKefuIds);
		},
		addKefu(scope) {
			if (!scope) {
				this.addScope = {
					call_type:1,
					call_style:0,
					call_name:'',
					call_code:'',
					pic:'',
					istype:0
				};
			} else {
				this.addScope = JSON.parse(JSON.stringify(scope));
			}
			this.dialogVisible = true;
		},
		submitRuleForm(formname) {
			this.$refs[formname].validate((valid, attr) => {
				if (valid) {
					this.addSubmit();
				} else {
					console.log('error submit!!', attr);
					return false;
				}
			});
		},
		addSubmit() {
			this.$confirm('确定提交？')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.advertType/addKefu',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							kefuInfo: this.addScope
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.dialogVisible = false;
								this.$message.success(res.data.msg);
								this.getKefuList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {
					console.log('取消');
				});
		},
		// 上传图片
		chooseIcon(){
			this.$refs.piclist.show();
		},
		chooseIconConfirm(e){
			console.log(e);
			this.addScope.pic = e.files;
		},
		delAdscopeImg() {
			this.addScope.pic = '';
			this.addScope[this.fileType[this.addScope.adtype - 1]] = '';
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown {
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
		}
	}
}
</style>
